import { format, parseISO } from "date-fns";
import { Droplet } from "lucide-react";
import { FLOWS, MOODS, SYMPTOM_LIST } from "@/lib/cycle";
import { SymptomTips } from "./SymptomTips";

const Chip = ({ on, onClick, children, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`rounded-full border px-3 py-1.5 text-xs font-medium transition-colors duration-200 ${on ? "border-[#9E4429] bg-[#9E4429] text-[#FBF5EE]" : "border-[#C86D51]/25 text-[#5C4A42] hover:border-[#9E4429]"}`}>
    {children}
  </button>
);

const Group = ({ label, children }) => (
  <div className="mt-4">
    <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#7A665C]">{label}</p>
    <div className="mt-2 flex flex-wrap gap-1.5">{children}</div>
  </div>
);

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

export const DayPanel = ({ iso, cycle, toggleStart, setLog }) => {
  const log = cycle.logs[iso] ?? {};
  const symptoms = log.symptoms ?? [];
  const isStart = cycle.starts.includes(iso);
  return (
    <div className="mt-6 border-t border-[#C86D51]/15 pt-5" data-testid="cycle-day-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="font-serif text-2xl text-[#2C221E]" data-testid="cycle-day-panel-date">{format(parseISO(iso), "EEEE d MMMM")}</p>
        {!cycle.pregnant && (
          <button type="button" onClick={() => toggleStart(iso)} data-testid="cycle-toggle-start-button"
            className={`flex items-center gap-1.5 rounded-full px-4 py-2 text-xs font-semibold transition-colors ${isStart ? "bg-[#A9503A] text-[#FBF5EE]" : "bg-[#2C221E] text-[#FBF5EE] hover:bg-[#9E4429]"}`}>
            <Droplet className="h-3.5 w-3.5" /> {isStart ? "Period started · undo" : "My period started"}
          </button>
        )}
      </div>
      <Group label="Flow">
        {FLOWS.map((f) => <Chip key={f} on={log.flow === f} onClick={() => setLog(iso, { flow: log.flow === f ? null : f })} testId={`cycle-flow-${slug(f)}`}>{f}</Chip>)}
      </Group>
      <Group label="Mood">
        {MOODS.map((m) => <Chip key={m} on={log.mood === m} onClick={() => setLog(iso, { mood: log.mood === m ? null : m })} testId={`cycle-mood-${slug(m)}`}>{m}</Chip>)}
      </Group>
      <Group label="Symptoms">
        {SYMPTOM_LIST.map((s) => (
          <Chip key={s} on={symptoms.includes(s)} testId={`cycle-symptom-${slug(s)}`}
            onClick={() => setLog(iso, { symptoms: symptoms.includes(s) ? symptoms.filter((x) => x !== s) : [...symptoms, s] })}>{s}</Chip>
        ))}
      </Group>
      <SymptomTips log={log} />
    </div>
  );
};
